<div class="overlay">

  <!-- Circles row: avatar left, optional user camera right -->
  <div class="circles-row">

    <!-- Avatar circle -->
    <div class="video-circle" aria-label="Avatar video">
      <qai-call-video
        [displayName]="''"
        [shape]="'circle'"
        [isSpeaking]="avatarIsSpeaking()" [description]="aiNotice() ?? undefined" nameBadgeKind="gray-dark"
        [indicatorStatus]="!avatarVideoPlaying() ? 'loading' : undefined"
      >
        <video
          videoSlot
          id="avatar-video-realtime"
          [appAvatarPlayer]="realtimeService()"
          [attr.playsinline]="true"
          [attr.webkit-playsinline]="true"
          class="video-realtime"
          (playing)="handleAvatarVideoPlaying()"
          (error)="handleAvatarVideoError()"
        ></video>
        @if (!avatarVideoPlaying()) {
          <qai-call-audio-indicator size="small" status="loading" />
        }
      </qai-call-video>
    </div>

    <audio
      id="avatar-audio-realtime"
      [attr.playsinline]="true"
      [attr.webkit-playsinline]="true"
    ></audio>

    <!-- User camera circle (optional) -->
    @if (showCameraStream()) {
      <div class="video-circle video-circle--user" aria-label="User camera">
        <qai-call-video
          [displayName]="''"
          [fullName]="userDisplayName()"
          [shape]="'circle'"
          [isSpeaking]="userIsSpeaking()"
          [showInitials]="showUserInitials()"
        >
          <video
            videoSlot
            id="user-video"
            [attr.playsinline]="true"
            [attr.webkit-playsinline]="true"
            autoplay
            muted
          ></video>
        </qai-call-video>
      </div>
    }

  </div>

  <!-- Captions — bottom-center of the overlay -->
  @if (captionsOn() && (captionText()?.trim()?.length ?? 0) > 0) {
    <div class="captions-wrapper"
         [style.--captions-width]="captionsMaxWidth() > 0 ? captionsMaxWidth() + 'px' : null">
      <qai-call-captions [maxLines]="4">
        {{ captionText() }}
      </qai-call-captions>
    </div>
  }

</div>
